
export class ReturnClass {
    draw: number;
    pagingSize?: number = 10;
    recordsTotal: number;
    recordsFiltered: number;
    data: Array<any>;

    constructor() {
    }
}

export class NewReturnClass<T> {
    draw: number;
    pagingSize?: number = 10;
    recordsTotal: number;
    recordsFiltered: number;
    data: Array<T>;

    constructor() {
    }
}

export class BaseeSearchClass {
    SortBy?: string;
    IsAsc?: boolean;
    PageSize?: number;
    PageIndex?: number;

    constructor() {
        this.PageIndex = 1;
        this.PageSize = 10;
        this.SortBy = '';
        this.IsAsc = false;

        const oUser = localStorage.getItem('user');
        if (oUser) {
            const curUser = JSON.parse(oUser);
            if(curUser.PagingSize) {
                this.PageSize = curUser.PagingSize;
            }
        }
    }
}

export interface HttpRetClass {
    TotalCount: number;
    DataList: Array<Array<string>>;
}


export interface ActionResultClass {
    Status: string;
    Message: string;
    Data: any;
}

export interface ResultClass {
    Success: boolean;
    Code: string;
    Message: string;
    Result: any;
}

export interface ActionResultData {
    TotalCount: number,
    DataList: any
}

export interface InitClass {
    DataTypes: Array<Array<string>>;
    DataSource: Array<Array<string>>;
    WorkFlowGroupList: Array<Array<string>>;
}

export interface InitMessageClass {
    DataQualityMessage: Array<Array<string>>;
}